import { createContext } from 'react';
import uuid from 'react-uuid';
import { decorate, observable, action, toJS } from 'mobx';

import api from '../api';
import * as fn from '../utilities/_functions';

export class WorkOrderTemplateCreate {
    id = null;
    data = {
        name: null,
        descriptionHtml: null,
        perUnit: 1,
    };
    isReady = false;
    isSaving = false;
    hasUnsavedChanges = false;

    cancelWorkOrderTemplateCreate = null;

    initialize = () => {
        this.clear();
        this.id = uuid();
        this.isReady = true;
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            if (that.hasUnsavedChanges) {
                api.WorkOrderTemplates.create(option, (c) => { that.cancelWorkOrderTemplateCreate = c })
                    .then(({ data }) => {
                        that.hasUnsavedChanges = false;
                        that.id = data.id;
                        option.id = data.id;
                        resolve(option);
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            } else {
                that.hasUnsavedChanges = false;
                that.isSaving = false;
                resolve(option);
            }
        })
    }

    clear = () => {
        this.id = null;
        this.data.name = null;
        this.data.descriptionHtml = null;
        this.data.perUnit = 1;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelWorkOrderTemplateCreate)) {
            this.cancelWorkOrderTemplateCreate();
            this.cancelWorkOrderTemplateCreate = null;
        }
    }
}

decorate(WorkOrderTemplateCreate, {
    id: observable,
    data: observable.deep,
    hasUnsavedChanges: observable,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    save: action,
    clear: action,
})

export default createContext(new WorkOrderTemplateCreate());